module.exports = __webpack_public_path__ + "img/switch_struttura.0bf6f893.svg";